import { useCallback, useContext } from 'react';
import { useNavigate } from "react-router-dom"
import cuestionarioService from '../../services/cuestionario.js';
import { GeneralContext } from "../../context/GeneralContext"
import { useUser } from '../useUser.jsx';

export const useFinalizarCuestionario = ({ idCuestionario }) => {

    const navigate = useNavigate()
    const { user } = useUser();
    const { setIdCuestionarioActual, setPerfilEmpresarial } = useContext(GeneralContext);
    

    const EnviarCuestionario = () => {
        var finCuestionario = cuestionarioService.finalizar(user)
        finCuestionario.then(
            (promiseFullFilled) => {
                setIdCuestionarioActual(idCuestionario)
                setPerfilEmpresarial();
                navigate("/Resultado")
            },
            (promiseError) => {
                console.error("Error: " + promiseError);
            }
        )
    } 

return { EnviarCuestionario };
}